var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initLineItemCard = /* @__PURE__ */ __name(($el, lineItemKey) => {
  const random_id = utils.shortUUID();
  const cart = Alpine.store("cart");
  const lineItem = Shopify.designMode ? cart.state.items.find((item) => item.key === lineItemKey) ?? cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
  let product = _products[lineItem?.handle];
  if (!product) {
    _product.getProductData(lineItem?.handle, lineItem?.product_id).then((prod) => {
      state.product = prod;
      state.variant = prod?.variants?.find((variant2) => variant2.id === lineItem?.variant_id);
      state.hydrated = true;
    });
  }
  product ?? (product = _products[lineItem?.handle]);
  const variant = product?.variants?.find((variant2) => variant2.id === lineItem?.variant_id);
  const state = window.Alpine.reactive({
    random_id,
    subscriptionIsChanging: false,
    hydrated: !!variant,
    line_item: lineItem,
    product,
    variant,
    url: lineItem?.url
  });
  const getDynamicValue = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicValue(content, state);
  }, "getDynamicValue");
  const getDynamicText = /* @__PURE__ */ __name((content) => {
    return utils.getBracketInputDynamicText(content, state);
  }, "getDynamicText");
  const getContentLabels = /* @__PURE__ */ __name((key) => {
    const labels = key.split(".").reduce((acc, selector) => {
      if (!selector || acc === void 0 || acc === null) return acc || "";
      if (acc && selector in acc) {
        return acc[selector];
      }
      return "";
    }, state);
    if (Array.isArray(labels)) {
      return labels.filter(Boolean);
    }
    return [labels].filter(Boolean);
  }, "getContentLabels");
  const hideIfEmpty = /* @__PURE__ */ __name((element, hide_if_empty, isEmpty = false) => {
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        element.closest(`.shopify-section`)?.classList.toggle("!hidden", isEmpty);
        break;
      case "container":
        element.closest(`[data-style-id]:not([data-style-id="${element.getAttribute("data-style-id")}"])`)?.classList.toggle("!hidden", isEmpty);
        break;
      case "block":
        break;
    }
  }, "hideIfEmpty");
  Alpine.effect(() => {
    const lineItem2 = Shopify.designMode ? cart.state.items.find((item) => item.key === lineItemKey) ?? cart.state.items[0] : cart.state.items.find((item) => item.key === lineItemKey);
    if (!utils.deepEqual(lineItem2, state.line_item)) {
      state.line_item = lineItem2;
    }
  });
  return {
    card: state,
    $el,
    getDynamicValue,
    getDynamicText,
    getContentLabels,
    hideIfEmpty
  };
}, "initLineItemCard");
const hydrateLineItemCard = /* @__PURE__ */ __name(($el, card_handle, line_item_key, classes = []) => {
  const node = document.querySelector(`[data-line-item-card='${card_handle}']`)?.cloneNode(true);
  if (!node) {
    $el.setAttribute("data-intersected", "true");
    const mo = new MutationObserver((mutation, obs) => {
      if ($el.hasAttribute("data-cards-loaded")) {
        $el.removeAttribute("data-intersected");
        const node2 = document.querySelector(`[data-line-item-card='${card_handle}']`)?.cloneNode(true);
        if (node2 && $el && $el.parentNode) {
          node2?.removeAttribute(`data-line-item-card`);
          node2?.setAttribute("data-line-item-key", line_item_key);
          node2.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
            el.remove();
          });
          node2.classList.add(...classes);
          $el.parentNode.replaceChild(node2, $el);
        }
        mo.disconnect();
      }
    });
    mo.observe($el, { attributes: true });
    return;
  }
  if (node && $el && $el.parentNode) {
    node?.removeAttribute(`data-line-item-card`);
    node?.setAttribute("data-line-item-key", line_item_key);
    node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
      el.remove();
    });
    node.classList.add(...classes);
    $el.parentNode.replaceChild(node, $el);
  }
}, "hydrateLineItemCard");
window._sections["initLineItemCard"] = initLineItemCard;
window._sections["hydrateLineItemCard"] = hydrateLineItemCard;
